// extracted by mini-css-extract-plugin
export default {"purpleLink":"styles__purpleLink___GhLtH","cyanLink":"styles__cyanLink___+HOue","cyanButton":"styles__cyanButton___Gx2gz","ampPage":"styles__ampPage___lahpi"};